import * as THREE from "three";
import {
  FILL_COLOR,
  FILL_DIR,
  HEMI_GROUND_COLOR,
  HEMI_SKY_COLOR,
  SUN_COLOR,
  SUN_DIR,
} from "./palette.js";

/**
 * The light rig for renders of a single object: the world rig's colours and
 * directions (`sky.ts`), only brighter, since there is no sky or ground bounce
 * — so a scope looks the same on the tile, the bench and in the hands. Fresh
 * lights every call: a `THREE.Light` belongs to one scene, and the portrait
 * renderer and the preview are alive at once.
 */
export function makePreviewLights(): THREE.Light[] {
  const hemi = new THREE.HemisphereLight(HEMI_SKY_COLOR, HEMI_GROUND_COLOR, 1.6);
  const sun = new THREE.DirectionalLight(SUN_COLOR, 1.5);
  sun.position.set(SUN_DIR.x, SUN_DIR.y, SUN_DIR.z);
  const fill = new THREE.DirectionalLight(FILL_COLOR, 0.55);
  fill.position.set(FILL_DIR.x, FILL_DIR.y, FILL_DIR.z);
  return [hemi, sun, fill];
}
